import axios from 'axios'
import url from '../baseUrl'
import Qs from 'qs';

let baseUrl = url.salaryUrl


function randomNum(minNum, maxNum) {
  return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
}
//设置黑名单
const $axiosSetBlacklist = params => axios.get(baseUrl + '/workerBase/addBlack', {
  params
});
//取消黑名单
const $axiosCancelBlacklist = params => axios.get(baseUrl + '/workerBase/removeBlack', {
  params
});
//公私海线索查询
const $axiosGetClueList = params => axios.post(baseUrl + '/workerClue/getCluePage',
  params );
const $axiosGetClueListNew = params => axios.get(baseUrl + '/workerClue/selectHHRPerson', {
  params
});
//线索详情
const $axiosGetClueInfo = params => axios.get(baseUrl + '/workerClue/getClueInfo', {
  params
});

//查询供应商，按照类型查1流量供应商，2服务力供应商，3合伙人供应商
const $axiosGetSupplierList = params => axios.get(baseUrl + '/source/getSupplier', {
  params
});

//新增线索
const $axiosAddWorkerClue = params => axios.post(baseUrl + '/workerClue/addWorkerClue', params);
//线索导出
const $axiosImport = params => axios.post(baseUrl + '/workerClue/importClue', params);
//线索导出
const $axiosExportClue  = params =>   axios
  .post(baseUrl + '/workerClue/getCluePage',
    params,
    {
      responseType: "blob",
    }
  )
  .then((response) => {
    let str = response.headers["content-disposition"]
      .split(";")[1]
      .split("=")[1];
    let fileName = decodeURI(str);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
//   this.importFileLoading = false;
  })
  .catch((response) => {
    console.log(response);
//   let fileName = '导出了.xlsx';
    let fileName = Date.parse(new Date()) + '线索.xlsx';
    console.log(fileName);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  });
//修改线索
const $axiosUpdateWorkerClue = params => axios.post(baseUrl + '/workerClue/updateWorkerClue', params);

//修改线索跟进人
const $axiosModifyHandler = params => axios.post(baseUrl + '/workerClue/setClueFollowUser', params);
//批量修改线索跟进人
const $axiosBatchSetClueFollowUser = params => axios.post(baseUrl + '/workerClue/batchSetClueFollowUser', params);


//获取线索跟进人列表
const $axiosGetHandlerList = params => axios.get(baseUrl + '/workerClue/queryClueFollowUser', {
  params
});


//查询工单或线索详细
const $axiosGetTicketOrClue = params => axios.get(baseUrl + '/crmTicket/getTicketDetail', {
  params
});

//获取技能组
const $axiosGetSkillGroup = params => axios.get(baseUrl + '/crmGroup/getAllSkillGroup', {
  params
});

//线索跟进记录
const $axiosGetTicketRemark = params => axios.get(baseUrl + '/workerClue/addFlowComment', {
  params
});

//跟进线索
const $axiosFollowClue = params => axios.post(baseUrl + '/workerClue/followClue', params);

//复活线索
const $axiosFollowAgain = params => axios.get(baseUrl + '/workerClue/followAgain', {params});

//线索流转
const $axiosGetClueAllocation = params => axios.get(baseUrl + '/workerClue/clueAllocation', {
  params
});

//线索完善
const $axiosPerfectWorkerClue = params => axios.post(baseUrl + '/workerClue/perfectWorkerClue', params);

//线索流失
const $axiosGetClueLoss = params => axios.get(baseUrl + '/workerClue/clueLoss', {
  params
});
//服务者上线
const $axiosGetTakeOffice = params => axios.get(baseUrl + '/workerClue/joinPosition', {
  params
});
//获取签约主体
const $axiosGetMainBody = params => axios.get(baseUrl + '/workerClue/getMainBody', {
  params
});

//获取服务者列表
const $axiosGetWorkerList = params => axios.post(baseUrl + '/workerBase/getPageList', params);

//身份证ocr
const $axiosWorkerOcrVerify = params => axios.post(baseUrl + '/workerBase/getOcrVerify', params);

//身份证ocr后 完善信息
const $axiosWorkerPerfectWorkerBase = params => axios.post(baseUrl + '/workerBase/perfectWorkerBase', params);
//修改个人信息
const $axiosWorkeUpdateInfo = params => axios.post(baseUrl + '/workerBase/updateInfo', params);

//背调
const $axiosWorkerInvestigation = params => axios.get(baseUrl + '/workerBase/identityInvestigation', {
  params
});

//测试背调
const $axiosBeidiaoTest = params => axios.get(baseUrl + '/workerBase/beidiaoTest', {
  params
});

//修改签约状态，这期只改状态,未来要钱保姆居间合同signContractState true签约
const $axiosWorkerUpdateSignContractState = params => axios.get(baseUrl + '/workerBase/updateSignContractState', {
  params
});

//正式上线-审批
const $axiosWorkerInduction = params => axios.get(baseUrl + '/workerBase/induction', {
  params
});
//审批上线
const $axiosEmploymentApproval = params => axios.get(baseUrl + '/workerBase/employmentApproval', {
  params
});

//服务者的 跟单，培训信息
const $axiosgetOnjobTraiEnrolment = params => axios.get(baseUrl + '/workerSupplier/getOnjobTraiEnrolment', {
  params
});
// //服务者 同步开通商城小程序账号
// const $axiosWorkerSyncOpenMall = params => axios.get(baseUrl + '/workerSupplier/syncAppletUser', { params });
//获取服务者基础信息
const $axiogetWorkerSupplier = params => axios.get(baseUrl + '/workerSupplier/getWorkerSupplier', {
  params
});
const $axiogetWorkerSupplierByNo = params => axios.get(baseUrl + '/workerSupplier/getWorkerSupplierByNo', {
  params
});
//查询解约，流失 类型
const $axiosgetLossleaveDict = params => axios.get(baseUrl + '/entryLeaveReinstate/getLossleaveDict', {
  params
});
// 解约，流失，复职 操作
const $axiosleaveOrLossOrReinstated = params => axios.post(baseUrl + '/workerBase/leaveOrLossOrReinstated', params);
//监听点击手机
const $axiosPhoneclick = params => axios.get(baseUrl + '/workerClue/phoneclick', {
  params
});
//取消师傅资格
const $axiosworkerBaseCancelMaster = params => axios.get(baseUrl + '/workerBase/cancelMaster', {
  params
});


//获取服务者详情
const $axiosGetWorkerInfo = params => axios.get(baseUrl + '/workerBase/getWorkerInfo', {
  params
});

//健康证上传
const $axiosAddWorkerCertificate = params => axios.post(baseUrl + '/workerBase/addWorkerCertificate', params);
//删除证件信息
const $axiosDeleteCertificate = params => axios.get(baseUrl + '/workerBase/deleteCertificate', {
  params
});

//获取合同要填充的字段
const $axiosGetContractSignField = params => axios.get(baseUrl + '/workerSign/getContractSignField', {
  params
});

//预览合同
const $axiosFillContractTemplate = params => axios.post(baseUrl + '/workerSign/fillContractTemplate', params);

//驿站列表
const $axiosGetStationPageList = params => axios.get(baseUrl + '/postStation/getStationPageList', {
  params
});
//新增驿站
const $axiosAddPostStation = params => axios.get(baseUrl + '/postStation/addPostStation', {
  params
});
//删除驿站
const $axiosDeletePostStation = params => axios.get(baseUrl + '/postStation/deletePostStation', {
  params
});
//查询驿站下拉框，可传用户id
const $axiosPostStationgetAllList = params => axios.get(baseUrl + '/postStation/getAllList', {
  params
});
//新增服务站
const $ajaxAddstation = params => axios.get(baseUrl + '/cityStation/addStation', {
  params
}) //新增驿站

//获取所有请假类型
const $ajaxworkerLeaveGetAllType = params => axios.get(baseUrl + '/workerLeave/getAllType', {
  params
})
//查询请假列表
const $ajaxworkerGetPageList = params => axios.post(baseUrl + '/workerLeave/getPageList', params)
//发起请假
const $ajaxworkerSubmitLeave = params => axios.post(baseUrl + '/workerLeave/submitLeave', params)
//审批请假
const $ajaxworkerApprovalLeave = params => axios.post(baseUrl + '/workerLeave/approvalLeave', params)
//取消请假
const $ajaxworkerCancelLeave = params => axios.get(baseUrl + '/workerLeave/cancelLeave', {
  params
})
//处理请假到盒马
const $ajaxLeaveHandleHMLeave = params => axios.get(baseUrl + '/workerLeave/handleHMLeave', {
  params
})
//查看请假期间的工单
const $ajaxGetDispatchOrder = params => axios.get(baseUrl + '/workerLeave/getDispatchOrder', {
  params
})

//查询服务者下拉框
const $ajaxWorkerSupplierGetWorker = params => axios.get(baseUrl + '/workerSupplier/getWorker', {
  params
})
//导出服务者信息
// const $ajaxWorkerExportWorker = params => axios.post(baseUrl + '/workerSupplier/exportWorker',  params )
// const $ajaxWorkerExportWorker = params => axios({
//     url:url + '/workerSupplier/exportWorker',
//     method:'post',
//     data: params,
//     responseType: 'blob'
// }).then(res => $handleToExcel(res));



const $ajaxWorkerExportWorker = params => axios
  .post(baseUrl + '/workerSupplier/exportWorker',
    params, {
      responseType: "blob",
    }
  )
  .then((response) => {
    let str = response.headers["content-disposition"]
      .split(";")[1]
      .split("=")[1];
    let fileName = decodeURI(str);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  })
  .catch((response) => {
    console.log(response);
    //   let fileName = '导出了.xlsx';
    let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx';
    console.log(fileName);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  });

const $ajaxWorkerExportWorkerNewYear = params => axios
  .post(baseUrl + '/workerNewYear/newYearSurveyExport',
    params, {
      responseType: "blob",
    }
  )
  .then((response) => {
    let str = response.headers["content-disposition"]
      .split(";")[1]
      .split("=")[1];
    let fileName = decodeURI(str);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  })
  .catch((response) => {
    console.log(response);
    //   let fileName = '导出了.xlsx';
    let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx';
    console.log(fileName);
    if (window.navigator.msSaveOrOpenBlob) {
      // 兼容 IE 10
      navigator.msSaveBlob(new Blob([response.data]), fileName);
    } else {
      let url = window.URL.createObjectURL(new Blob([response.data]));
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", `${fileName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    //   this.importFileLoading = false;
  });



//修改服务者来源
const $axiosWorkerupdateSource = params => axios.get(baseUrl + '/workerSupplier/updateSource', {
  params
});

//赋能培训----------------------
//获取所有课程
const $ajaxEmCourseGetAllCourseList = params => axios.get(baseUrl + '/emCourse/getAllCourseList', {
  params
})
//获取所有技能
const $ajaxEmCourseGetAllSkillDict = params => axios.get(baseUrl + '/emSkill/getAllSkillDict', {
  params
})
//获取所有讲师
const $ajaxEmCourseGetAllLecturer = params => axios.get(baseUrl + '/emCourse/getAllLecturer', {
  params
})
//查询课程列表
const $ajaxEmCourseGetPageList = params => axios.get(baseUrl + '/emCourse/getPageList', {
  params
})
//添加课程
const $ajaxEmCourseAddCourse = params => axios.post(baseUrl + '/emCourse/addCourse', params)
//修改课程
const $ajaxEmCourseUpdateCourse = params => axios.post(baseUrl + '/emCourse/updateCourse', params)
//停用课程
const $ajaxEmCourseDelCourse = params => axios.get(baseUrl + '/emCourse/delCourse', {
  params
})
//查询前30天的有效的课程
const $ajaxemCourseArrangementGetAll30Day = params => axios.get(baseUrl + '/emCourseArrangement/getAll30Day', {
  params
})
//查询课程安排列表
const $ajaxemCourseArrangementGetPageList = params => axios.get(baseUrl + '/emCourseArrangement/getPageList', {
  params
})
//添加课程安排
const $ajaxemCourseArrangementAdd = params => axios.post(baseUrl + '/emCourseArrangement/addCourseArrangement', params)
// 修改课程安排
const $ajaxemCourseArrangementUpdate = params => axios.post(baseUrl + '/emCourseArrangement/updateCourseArrangement', params)
//停用课程安排
const $ajaxemCourseArrangementStopCourse = params => axios.get(baseUrl + '/emCourseArrangement/updateCourse', {
  params
})
//查询学员列表
const $ajaxemEmCourseEnrolmentGetPageList = params => axios.get(baseUrl + '/emCourseEnrolment/getPageList', {
  params
})
//学员报课
const $ajaxemEmCourseEnrolmentAttendCourse = params => axios.post(baseUrl + '/emCourseEnrolment/attendCourse', params)
//取消报课
const $ajaxemEmCourseEnrolmentCancelCourse = params => axios.get(baseUrl + '/emCourseEnrolment/cancelCourse', {
  params
})
//老师课程评分
const $ajaxemEmCourseEnrolmentStudentScore = params => axios.post(baseUrl + '/emCourseEnrolment/studentScore', params)


//查询跟单列表
const $ajaxemCourseFollowGetPageList = params => axios.get(baseUrl + '/onJob/onjobList', {
  params
})

//查询可跟单人员列表
const $ajaxCanFollowGetPageList = params => axios.get(baseUrl + '/onJob/canOnJobList', {
  params
})
//查询师傅列表
const $ajaxMasterPageList = params => axios.get(baseUrl + '/onJob/onJobMasterList', {
  params
})
//查询师傅最近14天的盒马订单信息
const $ajaxMasterOrderList = params => axios.get(baseUrl + '/onJob/getOnJobByWorkerTel', {
  params
})

//申请跟单
const $ajaxStartOnJob = params => axios.post(baseUrl + '/onJob/startOnjob', params)
//添加子跟单项
const $ajaxAddOnJobItem = params => axios.post(baseUrl + '/onJob/addOnjobRecord', params);
//每个开始跟单
const $ajaxStartOnJobItem = params => axios.get(baseUrl + '/onJob/startToOnJob', {
  params
});

//完成子跟单并提交评语
const $ajaxAddOnJobItemComment = params => axios.get(baseUrl + '/onJob/finishSubOnJob', {
  params
});

//完成跟单
const $ajaxFinishOnJob = params => axios.post(baseUrl + '/onJob/finishOnjob', params);
//删除跟单记录
const $ajaxDeleteOnJobItem = params => axios.get(baseUrl + '/onJob/deleteOnjobRecord', {
  params
});
//取消歌单
const $ajaxCancelOnJob = params => axios.get(baseUrl + '/onJob/cancelOnjob', {
  params
});

//查询所有驿站
const $axiosGetAllPostStation = params => axios.get(baseUrl + '/postStation/queryCityPostStationAndStation', {
  params
});


//-----------------------宿舍-------------------------------
const $axiosGetDormitoryPageList = params => axios.get(baseUrl + '/workerDorm/dormList', {
  params
});
const $axiosDisableOrAbleDorm = params => axios.get(baseUrl + '/workerDorm/disableOrAbleDorm', {
  params
});
//创建宿舍
const $axiosAddDormitory = params => axios.post(baseUrl + '/workerDorm/addDorm', params);
//修改宿舍
const $axiosUpdateDormitory = params => axios.post(baseUrl + '/workerDorm/modifyDorm', params);
//根据宿舍ID查询当前已住宿的人员列表
const $axiosGetDormitoryUserList = params => axios.get(baseUrl + '/workerDorm/checkInList', {
  params
});
//修改宿舍容量
const $axiosUpdateDormitoryCapacity = params => axios.get(baseUrl + '/workerDorm/modifyDormMaxPeople', {
  params
});
//查询宿舍入住列表
const $axiosGetDormitoryCheckInList = params => axios.get(baseUrl + '/workerDorm/checkInList', {
  params
});
//查询可分配宿舍人员列表
const $axiosQueryAssignCleaners = params => axios.get(baseUrl + '/workerDorm/queryAssignCleaners', {
  params
});
//办理入住
const $axiosCheckIn = params => axios.post(baseUrl + '/workerDorm/checkIn', params);
//办理离宿
const $axiosCheckOut = params => axios.get(baseUrl + '/workerDorm/checkOut', {
  params
});
//修改离宿时间
const $axiosUpdateCheckOutTime = params => axios.get(baseUrl + '/workerDorm/modifyLeaveTime', {
  params
});
//审核离宿时间

const $axiosAuditModifyLeaveTime = params => axios.get(baseUrl + '/workerDorm/auditModifyLeaveTime', {
  params
});
//取消宿舍长
const $axiosCancelDormLeader = params => axios.get(baseUrl + '/workerDorm/cancelDormLeader', {
  params
});
//设置宿舍长
const $axiosSetDormLeader = params => axios.post(baseUrl + '/workerDorm/setDormLeader', params);
//发起宿舍停用申请
const $axiosApplyDisableDorm = params => axios.get(baseUrl + '/workerDorm/applyDisableDorm', {
  params
});
//宿舍停用审核
const $axiosAuditDisableDorm = params => axios.get(baseUrl + '/workerDorm/auditDisableDorm', {
  params
});
//-----------------------宿舍-------------------------------

//用户数据权限-----------
//获取用户数据page
const $ajaxemSysUserDataPagePageList = params => axios.get(baseUrl + '/sysUserData/pagePageList', {
  params
});
//添加用户数据
const $ajaxemSysUserDataAddUserData = params => axios.post(baseUrl + '/sysUserData/addUserData', params);
//修改用户数据
const $ajaxemSysUserDataUpdateUserData = params => axios.post(baseUrl + '/sysUserData/updateUserData', params);
//修改时，获取城市，驿站，服务站，数据

const $ajaxemSysUserDataGetUserDataCPS = params => axios.get(baseUrl + '/sysUserData/getUserDataCPS', {
  params
});
//获取用户拥有的城市，驿站，服务站,门店
const $ajaxemSysUserDataGetUserAuthData = params => axios.get(baseUrl + '/sysUserData/getUserAuthData', {
  params
});
//删除用户权限数据
const $ajaxemSysUserDataDeleteUserData = params => axios.get(baseUrl + '/sysUserData/deleteUserData', {
  params
});

//师徒关系--------
//查询师徒关系列表
const $ajaxemWorkerMentorGetPageList = params => axios.get(baseUrl + '/workerMentor/getPageList', {
  params
});
//添加师徒关系
const $ajaxemWorkerMentorAddWorkerMentor = params => axios.post(baseUrl + '/workerMentor/addWorkerMentor', params);
//取消师徒关系
const $ajaxemWorkerMentorCancelMentorRelate = params => axios.get(baseUrl + '/workerMentor/cancelMentorRelate', {
  params
});
//查询所有师傅
const $ajaxemWorkerMentorGetAllMentor = params => axios.get(baseUrl + '/workerMentor/getAllMentor', {
  params
});

/***************************服务者标签相关信息******************/
//标签列表
const $axiosWorkerLabelList = params => axios.get(baseUrl + '/workerDimLabel/list', {
  params
});
const $axiosWorkerLabelCreate = params => axios.post(baseUrl + '/workerDimLabel/create', params);
const $axiosWorkerLabelUpdate = params => axios.post(baseUrl + '/workerDimLabel/update', params);
const $axiosWorkerLabelDelete = params => axios.post(baseUrl + '/workerDimLabel/delete', params);
//返回所有2级标签
const $axiosWorkerLabelListAll2 = params => axios.get(baseUrl + '/workerDimLabel/listAll', {
  params
});
const $axiosWorkerLabelCateList = params => axios.get(baseUrl + '/workerDimLabelCategory/list', {
  params
});

/***************************指标维护相关信息******************/
//标签列表
const $axiosDimTargetList = params => axios.get(baseUrl + '/dimTarget/list', {
  params
});
const $axiosDimTargetCreate = params => axios.post(baseUrl + '/dimTarget/create', params);
const $axiosDimTargetUpdate = params => axios.post(baseUrl + '/dimTarget/update', params);
const $axiosDimTargetDelete = params => axios.post(baseUrl + '/dimTarget/delete', params);
const $axiosDimTargetListAll2 = params => axios.get(baseUrl + '/dimTarget/listAll', {
  params
});

/***************************面板数据******************/
const $axiosWorker360view = params => axios.get(baseUrl + '/worker360/workerBaseInfoAndCalendar', {
  params
});
// 获取人员当日工单信息
const $axiosGetPersonTradeByDay = params => axios.get(baseUrl + '/worker360/getPersonTradeByDay', {
  params
});
const $axiosGetWorkerJobLog = params => axios.post(baseUrl + '/worker360/getWorkerJobLog', params);

//管理者看板
//查询服务者生命指标
const $axiosManagerViewWorkerLifeIndicators = params => axios.get(baseUrl + '/managerView/workerLifeIndicators', {
  params
});
//查询站点数据：库存，复购，服务 指标
const $axiosManagerViewGetManagerboardData = params => axios.get(baseUrl + '/managerView/getManagerboardData', {
  params
});


//获取站长看板
const $axioGetStationDashboardTrade = params => axios.get(baseUrl + '/workerDataBoard/getStationTrade', {
  params
});
const $axioGetStationDashboardDaily = params => axios.get(baseUrl + '/workerDataBoard/getStationDaily', {
  params
}); //站点工作台，每日任务
const $axioGetStationDashboardTradeByDay = params => axios.get(baseUrl + '/workerDataBoard/getStationTradeByDay', {
  params
}); //日历看板中的每日工单
const $axioGetStationDashboardSuspendTradeByDay = params => axios.get(baseUrl + '/workerDataBoard/getStationSuspendTradeByDay', {
  params
}); //日历看板中的每日挂单
const $axioGetStationDashboardServiceRebuy = params => axios.get(baseUrl + '/workerDataBoard/getStationServiceRebuy', {
  params
}); //站长看板复购服务指标数据
//画像
const $axiosDimProfileList = params => axios.get(baseUrl + '/workerDimProfile/list', {
  params
});
const $axiosDimProfileCreate = params => axios.post(baseUrl + '/workerDimProfile/create', params);
const $axiosDimProfileUpdate = params => axios.post(baseUrl + '/workerDimProfile/update', params);
const $axiosDimProfileDelete = params => axios.post(baseUrl + '/workerDimProfile/delete', params);
const $axiosDimProfileEstimate = params => axios.post(baseUrl + '/workerDimProfile/estimate', params);
const $axiosDimProfileRead = params => axios.get(baseUrl + '/workerDimProfile/read', {
  params
});
const $axiosDimProfileAll = params => axios.get(baseUrl + '/workerDimProfile/all', {
  params
});
const $axiosDimProfileEtl = params => axios.get(baseUrl + '/workerDimProfile/etl', {
  params
});

//服务者标签，技能
//查询标签列表
const $axiosEmLableSkillGetPageList = params => axios.get(baseUrl + '/emLableSkill/getPageList', {
  params
});
//获取所有标签
const $axiosEmLableSkillGetAllLabelSkill = params => axios.get(baseUrl + '/emLableSkill/getAllLabelSkill', {
  params
});
//添加标签
const $axiosEmLableSkillAddLabelSkill = params => axios.get(baseUrl + '/emLableSkill/addLabelSkill', {
  params
});
//修改标签
const $axiosEmLableSkillUpdateLabelSkill = params => axios.get(baseUrl + '/emLableSkill/updateLabelSkill', {
  params
});
//修改标签
const $axiosEmLableSkillDeleteLabelSkill = params => axios.get(baseUrl + '/emLableSkill/deleteLabelSkill', {
  params
});
//查询技能列表
const $axiosEmSkillGetPageList = params => axios.get(baseUrl + '/emSkill/getPageList', {
  params
});
//添加技能
const $axiosEmSkillAddSkill = params => axios.get(baseUrl + '/emSkill/addSkill', {
  params
});
//删除技能
const $axiosEmSkillDeleteSkill = params => axios.get(baseUrl + '/emSkill/deleteSkill', {
  deleteSkill
});

//管家账号列表
const $axiosSysUserBrokerPagePageList = params => axios.get(baseUrl + '/sysUserBroker/pagePageList', {
  params
});
//添加管家账号
const $axiosSysUserBrokerAddUserBroker = params => axios.post(baseUrl + '/sysUserBroker/addUserBroker', params);
//管家账号解除1，启用0
const $axiosSysUserBrokerUnbind = params => axios.get(baseUrl + '/sysUserBroker/unbind', {
  params
});
// 同步用户信息
const $axiossyncWorkerData = params => axios.get(baseUrl + '/sysUser/syncWorkerData', {
  params
});

// 获取鲸选订单列表
const $axiosGetJxOrderList = params => axios.get(baseUrl + '/jxAunt/jxOrderList', {
  params
});
// 手动同步订单状态
const $axiosRefreshOrderStatus = params => axios.get(baseUrl + '/jxAunt/refreshOrderStatus', {
  params
});
//保洁收入
const $axiosHhrSalaryList = params => axios.post(baseUrl + '/hhrSalary/getPageList', params);


// 企微标签
const $axiosCpTagList = params => axios.get(baseUrl + '/cpTag/list', {
  params
});
const $axiosCpTagUpdate = params => axios.post(baseUrl + '/cpTag/update', params);
const $axiosCpTagAsync = params => axios.get(baseUrl + '/cpTag/asyncTag', {
  params
});

//企微客户（商家）
const $axiosCpWorkerList = params => axios.get(baseUrl + '/cpWorker/list', {
  params
});
const $axiosCpChatWorkerList = params => axios.get(baseUrl + '/cpWorker/listChatWorker', {
  params
});
const $axiosCpWorkerAsync = params => axios.get(baseUrl + '/cpWorker/asyncWorker', {
  params
});
const $axiosCpMarkTagAsync = params => axios.get(baseUrl + '/cpWorker/asyncMarkTag', {
  params
}); //批量标签
const $axiosCpMessageSync = params => axios.get(baseUrl + '/cpMessage/sync', {
  params
}); //同步会话
const $axiosCpGetMsg = params => axios.get(baseUrl + '/cpMessage/getMsg', {
  params
}); //获取指定商家的聊天记录
const $axiosCpGetUserList = params => axios.get(baseUrl + '/cpUser/getUserList', {
  params
}); //获取有聊天记录的管家


//课程资源
const $axiosFileossList = params => axios.get(baseUrl + '/fileoss/getPageList', {
  params
})
const $axiosFileCreate = params => axios.get(baseUrl + '/fileoss/create', {
  params
})
const $axiosSyncUploadInfo = params => axios.get(baseUrl + '/fileoss/syncUploadInfo', {
  params
})
const $axiosFileDelete = params => axios.get(baseUrl + '/fileoss/delete', {
  params
})
const $axiosGetCategoryLevelTwo = params => axios.get(baseUrl + '/emCourse/getCategoryLevelTwo', {
  params
})
const $axiosGetAllCourseList = params => axios.get(baseUrl + '/emCourse/getAllCourseList', {
  params
})
//添加课程
const $axiosAddCourse = params => axios.post(baseUrl + '/emCourse/addNewCourse', params)

//待跟单阿姨选定日期后查询所有同城市阿姨的当天跟单信息
const $ajaxGetOnJobList = params => axios.get(baseUrl + '/onJob/getOnJobList', {
  params
})

//商家运营
const $axiosWorkerManagerGetPageList = params => axios.get(baseUrl + '/workerManager/getPageList', {
  params
});
const $axiosWorkerManagerCreate = params => axios.post(baseUrl + '/workerManager/create', params);
const $axiosWorkerManagerUpdate = params => axios.post(baseUrl + '/workerManager/update', params);
const $axiosWorkerManagerAll = params => axios.get(baseUrl + '/workerManager/getAll', {
  params
});


//添加区域
const $ajaxAddArea = params => axios.post(baseUrl + '/rangArea/addArea', params);
//绑定服务区域
const $ajaxBindWorkerArea = params => axios.post(baseUrl + '/rangArea/bindWorkerArea', params);
//切割区域
const $ajaxCutArea = params => axios.get(baseUrl + '/rangArea/cutArea', {
  params
});
//删除区域
const $ajaxDelArea = params => axios.get(baseUrl + '/rangArea/delArea', {
  params
});
//获取某城市的区域一二级
const $ajaxGetCityRang = params => axios.get(baseUrl + '/rangArea/getCityRang', {
  params,
  paramsSerializer: function (params) {
    return Qs.stringify(params, {
      arrayFormat: "repeat"
    });
  },
});
//获取某城市的区域一级
const $ajaxGetCityLevelOne = params => axios.get(baseUrl + '/rangArea/getCityLevelOne', {
  params
});
//修改区域名称
const $ajaxUpdateAreaName = params => axios.get(baseUrl + '/rangArea/updateAreaName', {
  params
});
//获取城市区域，作为下拉框
const $ajaxGetCityNoCutRange = params => axios.get(baseUrl + '/rangArea/getCityNoCutRange', {
  params,
  paramsSerializer: function (params) {
    return Qs.stringify(params, {
      arrayFormat: "repeat"
    });
  },
});
//获取服务者的接单区域id
const $ajaxGetWorkerAreaId = params => axios.get(baseUrl + '/rangArea/getWorkerAreaId', {
  params
});
//获取服务者的接单区域详细信息
const $ajaxGetWorkerAreaInfo = params => axios.get(baseUrl + '/rangArea/getWorkerAreaInfo', {
  params
});
const $ajaxSelectAreaWorker = params => axios.get(baseUrl + '/rangArea/selectAreaWorker', {
  params
});

const $resendInterviewMsg = params => axios.get(baseUrl + '/workerInterview/resendMessage', {
  params
});

const $ajaxGeocode = params => axios.get(baseUrl + '/restapi/getAddressLngLat', {
  params
});

const $ajaxSelectAreaFranChisee = params => axios.get(baseUrl + '/rangArea/selectAreaFranChisee', {
  params
});

const $ajaxAddCityPolyline = params => axios.get(baseUrl + '/rangArea/addCityPolyline', {
  params
});

const $ajaxCutAreaThree = params => axios.get(baseUrl + '/rangArea/cutAreaThree', {
  params
});

const $ajaxCrmGetWorkerBookTradeNear = params => axios.get(baseUrl + '/crmBookTrade/getWorkerBookTradeNear', {
  params
});



//获取所有加盟商
const $ajaxgetAllJms = params => axios.get(baseUrl + '/jmsFranchisee/getAllJms', {
  params
});
///jzworkerapiservice/workerMentor/queryMentorRelate
const $ajaxqueryMentorRelate = params => axios.get(baseUrl + '/workerMentor/queryMentorRelate', {
  params
});


const $ajaxgetWorkerNameList = params => axios.get(baseUrl + '/onJob/getWorkerNameList', {
  params
});


//驿站老师
const $axiosWorkerPostLeaderGetPageList = params => axios.get(baseUrl + '/workerPostLeader/getPageList', {
  params
});
const $axiosWorkerPostLeaderCreate = params => axios.post(baseUrl + '/workerPostLeader/create', params);
const $axiosWorkerPostLeaderUpdate = params => axios.post(baseUrl + '/workerPostLeader/update', params);
const $axiosWorkerPostLeaderAll = params => axios.get(baseUrl + '/workerPostLeader/getAll', {
  params
});


const $ajaxWorkerApplyTeamList = params => axios.get(baseUrl + '/workerApplyTeam/pageList', {
  params
});

const $ajaxOperApplyTeam = params => axios.get(baseUrl + '/workerApplyTeam/operApplyTeam', {
  params
});

//查询招招盈海报
const $ajaxGetZzyPoster = params => axios.get(baseUrl + '/workerSupplier/getZzyPoster', {
  params
});
//修改招招盈海报
const $ajaxUpdateZzyPoster = params => axios.get(baseUrl + '/workerSupplier/updateZzyPoster', {
  params
});
//保洁服务合作协议重签
const $ajaxResetSignContract = params => axios.get(baseUrl + '/workerSupplier/resetSignContract', {
  params
})
//美团人员录入，背调
const $axiosaddMeiTuanWorker = params => axios.post(baseUrl + '/workerSupplier/addMeiTuanWorker', params);
const $axiosgetOcrVerifyNew = params => axios.post(baseUrl + '/workerSupplier/getOcrVerifyNew', params);


//导出返回值 统一处理方法
const $handleToExcel = (res) => {
  // let blob = new Blob([res.data], {
  //     type: 'application/vnd.ms-excel'
  // });
  // let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx'
  // if (window.navigator.msSaveOrOpenBlob) {
  //     navigator.msSaveBlob(blob, fileName)
  // } else {
  //     var link = document.createElement('a')
  //     link.href = window.URL.createObjectURL(blob)
  //     link.download = fileName
  //     link.click()
  //     //释放内存
  //     window.URL.revokeObjectURL(link.href)
  // }


  let reader = new FileReader();

  reader.readAsDataURL(res);
  // let fileName = Date.parse(new Date()) + randomNum(1, 1200) + '.xlsx'

  reader.onload = (e) => {

    let a = document.createElement('a');

    a.download = `doc_${new Date().Format('yyyy_MM_dd')}.xlsx`

    a.href = e.target.result;

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);

  }
}
//修改个人位置
const $axiosUpdateServicePosition = params => axios.get(baseUrl + '/workerBase/updateServicePosition', {
  params
});
//个人位置修改记录
const $axiosGetWorkerHistoryUpdateArea = params => axios.get(baseUrl + '/workerBase/getWorkerHistoryUpdateArea', {
  params
});

/**
 * 工人CRM相关API接口
 * @namespace workercrmapi
 */
export default {
  $axiosSetBlacklist,
  $axiosCancelBlacklist,
  $ajaxUpdateZzyPoster,
  $ajaxGetZzyPoster,
  $resendInterviewMsg,
  $axiosGetClueList,
  $axiosGetClueInfo,
  $axiosGetSupplierList,
  $axiosAddWorkerClue,
  $axiosImport,
  $axiosExportClue,
  $axiosUpdateWorkerClue,
  $axiosGetClueLoss,
  $axiosGetClueAllocation,
  $axiosGetSkillGroup,
  $axiosGetTicketRemark,
  $axiosGetTicketOrClue,
  $axiosGetTakeOffice,
  $axiosPerfectWorkerClue,
  $axiosGetWorkerList,
  $axiosWorkerOcrVerify,
  $axiosWorkerInvestigation,
  $axiosBeidiaoTest,
  $axiosWorkerUpdateSignContractState,
  $axiosWorkerInduction,
  $axiosEmploymentApproval,
  $axiosgetOnjobTraiEnrolment,
  $axiosgetLossleaveDict,
  $axiosleaveOrLossOrReinstated,
  $axiosPhoneclick,
  $axiosworkerBaseCancelMaster,
  $axiosWorkerPerfectWorkerBase,
  $axiosWorkeUpdateInfo,
  $axiosGetWorkerInfo,
  $axiosAddWorkerCertificate,
  $axiosDeleteCertificate,
  $axiosGetContractSignField,
  $axiosFillContractTemplate,

  $axiosWorkerLabelList,
  $axiosWorkerLabelCreate,
  $axiosWorkerLabelUpdate,
  $axiosWorkerLabelDelete,
  $axiosWorkerLabelListAll2,
  $axiosWorkerLabelCateList,

  $axiosDimTargetList,
  $axiosDimTargetCreate,
  $axiosDimTargetUpdate,
  $axiosDimTargetDelete,
  $axiosDimTargetListAll2,
  $axiosGetStationPageList,
  $axiosAddPostStation,
  $axiosDeletePostStation,
  $axiosPostStationgetAllList,
  $ajaxAddstation,
  $axiosGetAllPostStation,


  $axiosGetDormitoryPageList,
  $axiosDisableOrAbleDorm,
  $axiosAddDormitory,
  $axiosUpdateDormitory,
  $axiosGetDormitoryUserList,
  $axiosUpdateDormitoryCapacity,
  $axiosGetDormitoryCheckInList,
  $axiosQueryAssignCleaners,
  $axiosCheckIn,
  $axiosCheckOut,
  $axiosUpdateCheckOutTime,
  $axiosAuditModifyLeaveTime,
  $axiosSetDormLeader,
  $axiosApplyDisableDorm,
  $axiosAuditDisableDorm,


  $ajaxworkerLeaveGetAllType,
  $ajaxworkerGetPageList,
  $ajaxworkerSubmitLeave,
  $ajaxworkerApprovalLeave,
  $ajaxworkerCancelLeave,
  $ajaxLeaveHandleHMLeave,
  $ajaxGetDispatchOrder,
  $ajaxWorkerSupplierGetWorker,

  $ajaxEmCourseGetAllCourseList,
  $ajaxEmCourseGetAllSkillDict,
  $ajaxEmCourseGetAllLecturer,
  $ajaxEmCourseGetPageList,
  $ajaxEmCourseAddCourse,
  $ajaxEmCourseUpdateCourse,
  $ajaxEmCourseDelCourse,


  $ajaxemCourseArrangementGetAll30Day,
  $ajaxemCourseArrangementGetPageList,
  $ajaxemCourseArrangementAdd,
  $ajaxemCourseArrangementUpdate,
  $ajaxemCourseArrangementStopCourse,
  $axiosCancelDormLeader,
  $ajaxemCourseFollowGetPageList,
  $ajaxCanFollowGetPageList,
  $ajaxMasterPageList,
  $ajaxStartOnJob,
  $ajaxMasterOrderList,
  $ajaxAddOnJobItem,
  $ajaxStartOnJobItem,
  $ajaxDeleteOnJobItem,
  $ajaxAddOnJobItemComment,
  $ajaxFinishOnJob,
  $ajaxCancelOnJob,
  $ajaxemEmCourseEnrolmentGetPageList,
  $ajaxemEmCourseEnrolmentAttendCourse,
  $ajaxemEmCourseEnrolmentCancelCourse,
  $ajaxemEmCourseEnrolmentStudentScore,

  $ajaxemSysUserDataPagePageList,
  $ajaxemSysUserDataAddUserData,
  $ajaxemSysUserDataUpdateUserData,
  $ajaxemSysUserDataGetUserDataCPS,
  $ajaxemSysUserDataGetUserAuthData,
  $ajaxemSysUserDataDeleteUserData,

  $ajaxemWorkerMentorGetPageList,
  $ajaxemWorkerMentorAddWorkerMentor,
  $ajaxemWorkerMentorCancelMentorRelate,
  $ajaxemWorkerMentorGetAllMentor,

  $axiosWorker360view,
  $axiosGetPersonTradeByDay,
  $axiosGetWorkerJobLog,

  $axiosManagerViewWorkerLifeIndicators,
  $axiosManagerViewGetManagerboardData,

  $axioGetStationDashboardTrade,
  $axioGetStationDashboardDaily,
  $axioGetStationDashboardTradeByDay,
  $axioGetStationDashboardSuspendTradeByDay,
  $axioGetStationDashboardServiceRebuy,

  $axiosDimProfileList,
  $axiosDimProfileCreate,
  $axiosDimProfileUpdate,
  $axiosDimProfileDelete,
  $axiosDimProfileEstimate,
  $axiosDimProfileRead,
  $axiosDimProfileAll,
  $axiosDimProfileEtl,
  // $axiosWorkerSyncOpenMall,
  $axiogetWorkerSupplier,
  $axiogetWorkerSupplierByNo,
  $ajaxWorkerExportWorker,
  $ajaxWorkerExportWorkerNewYear,
  $axiosWorkerupdateSource,

  $axiosEmLableSkillGetPageList,
  $axiosEmLableSkillGetAllLabelSkill,
  $axiosEmLableSkillAddLabelSkill,
  $axiosEmLableSkillUpdateLabelSkill,
  $axiosEmLableSkillDeleteLabelSkill,
  $axiosEmSkillGetPageList,
  $axiosEmSkillAddSkill,
  $axiosEmSkillDeleteSkill,

  $axiosSysUserBrokerPagePageList,
  $axiosSysUserBrokerAddUserBroker,
  $axiosSysUserBrokerUnbind,
  $axiossyncWorkerData,
  $axiosGetJxOrderList,
  $axiosRefreshOrderStatus,
  $axiosHhrSalaryList,

  $axiosCpTagList,
  $axiosCpTagUpdate,
  $axiosCpTagAsync,
  $axiosCpWorkerList,
  $axiosCpWorkerAsync,
  $axiosCpMarkTagAsync,
  $axiosCpMessageSync,
  $axiosCpChatWorkerList,
  $axiosCpGetMsg,
  $axiosCpGetUserList,

  $axiosFileossList,
  $axiosFileCreate,
  $axiosSyncUploadInfo,
  $axiosFileDelete,
  $axiosGetCategoryLevelTwo,
  $axiosGetAllCourseList,
  $axiosAddCourse,

  $ajaxGetOnJobList,
  $axiosWorkerManagerGetPageList,
  $axiosWorkerManagerCreate,
  $axiosWorkerManagerUpdate,

  $axiosWorkerManagerAll,
  $ajaxAddArea,
  $ajaxBindWorkerArea,
  $ajaxCutArea,
  $ajaxDelArea,
  $ajaxGetCityRang,
  $ajaxGetCityLevelOne,
  $ajaxUpdateAreaName,
  $ajaxGetCityNoCutRange,
  $ajaxGetWorkerAreaId,
  $ajaxSelectAreaWorker,
  $ajaxGetWorkerAreaInfo,
  $ajaxGeocode,
  $ajaxSelectAreaFranChisee,
  $ajaxAddCityPolyline,
  $ajaxCutAreaThree,

  $ajaxgetAllJms,
  $ajaxqueryMentorRelate,
  $axiosGetClueListNew,
  $axiosModifyHandler,
  $axiosBatchSetClueFollowUser,
  $axiosGetHandlerList,
  $axiosFollowClue,
  $axiosFollowAgain,

  $ajaxCrmGetWorkerBookTradeNear,
  $ajaxgetWorkerNameList,
  $axiosGetMainBody,
  $axiosWorkerPostLeaderGetPageList,
  $axiosWorkerPostLeaderCreate,
  $axiosWorkerPostLeaderUpdate,
  $axiosWorkerPostLeaderAll,
  $ajaxWorkerApplyTeamList,
  $ajaxOperApplyTeam,
  $axiosUpdateServicePosition,
  $axiosGetWorkerHistoryUpdateArea,
  $ajaxResetSignContract,
  $axiosaddMeiTuanWorker,
  $axiosgetOcrVerifyNew


}
